/** The client's brand, from client.json at build time (one dashboard build per client). */
import client from '../../../client.json';
import type { Language } from './i18n.ts';

export function appTitle(language: Language): string {
  return language === 'ar' ? `إعلانات ${client.brand.ar}` : `${client.brand.en} Ads`;
}
